import React, { useCallback, useMemo } from 'react';
import Button from '../../../../../styled/Button';
import { Column, Columns } from '../../../../../styled/Columns/wrappers';
import { FilterAltIcon } from '../../../../../styled/Icon';
import OverflowSlider from '../../../../../styled/OverflowSlider';
import useFilters from '../../Providers/useFilters';
import groupFilters from './FiltersAndSortPanel/FilterList/groupFilters';

interface IPromotedFilters {
  toggleShowPanel: (section?: string) => void;
}

interface IPromotedFilterButton {
  active?: boolean;
  name: string;
  onClick: () => void;
  filterIcon?: boolean;
}

const PromotedFilterButton = ({ active, name, onClick, filterIcon }: IPromotedFilterButton) => {
  return (
    <Button tone={(!active && 'soft') || undefined} onClick={onClick}>
      {name}
      {filterIcon && <FilterAltIcon className="bump-left" />}
    </Button>
  );
};

export default function PromotedFilters({ toggleShowPanel }: IPromotedFilters) {
  const { regularFilters, updateRegularFilters, isSelectedFilter } = useFilters();

  const promotedFilters = useMemo(
    () => groupFilters(regularFilters?.filter((b) => b.promoted)) || [],
    [regularFilters],
  );

  const onSelectPromotedFilter = useCallback(
    (title: string) => {
      const availableFilter = regularFilters.find(({ name }) => name === title);

      if (availableFilter?.type === 'switch') {
        const args = isSelectedFilter(availableFilter.property) ? undefined : { selected: true };
        updateRegularFilters(availableFilter.property, args);
        return;
      }

      if (availableFilter?.type === 'multiSwitch' && !!availableFilter?.options?.length) {
        const args = isSelectedFilter(availableFilter.property)
          ? undefined
          : availableFilter.options?.reduce((acc, o) => ({ ...acc, [o]: true }), {});
        updateRegularFilters(availableFilter.property, args);
        return;
      }

      toggleShowPanel(title);
    },
    [regularFilters, updateRegularFilters, isSelectedFilter],
  );

  return (
    <>
      <OverflowSlider stepSize={1 / 2}>
        <Columns className="space-1">
          <Column>
            <PromotedFilterButton name="Sortering" onClick={() => toggleShowPanel('sort')} />
          </Column>

          {promotedFilters.map((filter) => (
            <Column key={filter.title}>
              <PromotedFilterButton
                active={!!filter.availableFilters.find((b) => isSelectedFilter(b.property))}
                name={filter.title}
                onClick={() => onSelectPromotedFilter(filter.title)}
              />
            </Column>
          ))}

          <Column>
            <PromotedFilterButton name="Alla filter" onClick={() => toggleShowPanel()} filterIcon />
          </Column>
        </Columns>
      </OverflowSlider>
    </>
  );
}
